<ng-container [formGroup]="form">
	<ckeditor
		[config]="editorConfig$ | async"
		[editor]="editor"
		class="block"
		formControlName="biography"
	></ckeditor>
	<div class="flex flex-row items-center justify-end" style="margin-top: 30px">
		<button
			*ngIf="!(isSaving$ | async)"
			[label]="
				'presentation.app.page.settings.coach.biography.submit.label' | translate
			"
			(click)="onUpdateClick()"
			pButton
		></button>
		<p-progressSpinner
			*ngIf="isSaving$ | async"
			[style]="{ width: '30px', height: '30px' }"
		></p-progressSpinner>
	</div>
</ng-container>
